import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage, injectIntl} from 'react-intl';
import {withRouter} from 'react-router-dom';
import {MODAL_TYPE, showModal} from '../../forecast-app/shared/components/modals/generic_modal_conductor';
import CreateTaskMutation from '../../mutations/create_task_mutation';
import Util from '../../forecast-app/shared/util/util';
import {EVENT_ID, dispatch} from '../../containers/event_manager';
import {createTask} from '../../components/scheduling/scheduling_mutations';
import FinancialLockIcon from './FinancialLockIcon';
import {hasPermission, isClientUser} from '../../forecast-app/shared/util/PermissionsUtil';
import {PERMISSION_TYPE} from '../../Permissions';
import Styled from 'styled-components';
import {ClientIcon, ConnectedProjectIcon, ExpenseIcon, ProjectIcon, ReportIcon, TaskIcon, TeamMemberIcon, TimeEntryIcon} from 'web-components/icons';
import { hasFeatureFlag } from '../../forecast-app/shared/util/FeatureUtil';

class CreateNewMenu extends Component {
	constructor(props) {
		super(props);

		this.state = {
			expanded: false,
			focusNewTaskRef: false,
		};
	}

	componentDidUpdate() {
		if (this.state.focusNewTaskRef) {
			this.newTaskRef.focus();
			this.setState({focusNewTaskRef: false});
		}
	}

	handleCreateProject() {
		showModal({
			type: MODAL_TYPE.NEW_PROJECT_V2,
		});
		this.setState({expanded: false});
	}

	handleCreateTeamMember() {
		showModal({
			type: MODAL_TYPE.ADD_TEAM_MEMBER,
			addClientUser: false,
			companyId: this.props.viewer.company.id,
			buttonLocation: 'Header',
		});
		this.setState({expanded: false});
	}

	handleCreateClient() {
		showModal({
			type: MODAL_TYPE.ADD_CLIENT,
		});
		this.setState({addNewExpanded: false});
	}

	handleCreateInsight() {
		this.props.history.push('/insights/new/step1');
		this.setState({expanded: false});
	}

	handleCreateExpenseItem() {
		showModal({
			type: MODAL_TYPE.EXPENSE_ITEM,
			projectId: this.props.viewer.project ? this.props.viewer.project.id : null,
		});
		this.setState({expanded: false});
	}

	handleCreateTask() {
		if (this.props.project && this.props.project.status !== 'HALTED' && this.props.project.status !== 'DONE' && window.location.pathname.toLowerCase().includes('project')) {
			const onSuccess = result => {
				this.props.showTaskModal(result.createTask.task.node.companyTaskId, true);
			};

			const isScheduling = window.location.pathname.includes('schedul');
			if (isScheduling) {
				const mutationObject = {
					projectId: this.props.project.id,
					name: '',
					socketClientId: Util.getClientId(),
				};
				createTask(mutationObject, response => {
					this.props.showTaskModal(response.createTask.task.node.companyTaskId + '', true, true, true);
					dispatch(EVENT_ID.SCHEDULING_MODAL_MUTATION_SUCCESS, response);
				});
			} else {
				Util.CommitSchedulingModalUpdate(
					CreateTaskMutation,
					{
						projectId: this.props.project.id,
						name: '',
						companyId: this.props.viewer.company.id,
						placementOfTask: 'TOP',
					},
					onSuccess
				);
			}
		} else {
			const groupId = this.props.projectGroup ? this.props.projectGroup.id : null;
			const groupName = this.props.projectGroup ? this.props.projectGroup.name : null;
			showModal({type: MODAL_TYPE.TASK_LOCATION, viewerId: this.props.viewer.id, currentProjectGroupId: groupId, currentProjectGroupName: groupName});
		}
		this.setState({expanded: false});
	}

	handleCreateProjectGroup() {
		showModal({
			type: MODAL_TYPE.ADD_PROJECT_GROUP,
		});
		this.setState({expanded: false});
	}

	handleCreateTimeEntry() {
		showModal({
			type: MODAL_TYPE.TIMER_V3,
			isPreviousTimerReminder: false,
			timerProject: null,
			timerTask: null,
			useTimer: false,
		});
		this.setState({expanded: false});
	}

	toggleDropdown(e) {
		e.preventDefault();
		if (!this.state.expanded) {
			this.buttonRef.focus();
		}

		this.setState({expanded: !this.state.expanded});
	}

	handleBlur(e) {
		const newTarget = e.relatedTarget || e.explicitOriginalTarget || document.activeElement; // IE11
		if (newTarget && newTarget.className && newTarget.className.includes('create-new-option')) return;
		this.setState({expanded: false});
	}

	handleKeyPress(e) {
		if (e.keyCode === 27 && this.state.expanded) {
			// Escape
			this.buttonRef.focus();
			this.setState({expanded: false});
		} else if (e.keyCode === 40) {
			// Down arrow
			if (!this.state.expanded) {
				this.setState({expanded: true, focusNewTaskRef: true});
			} else {
				this.focusNextInList();
			}
		} else if (e.keyCode === 38 && this.state.expanded) {
			// Up arrow
			this.focusPreviousInList();
		} else if (e.keyCode === 13 || e.keyCode === 32) {
			// Enter / Space
			const focusedElement = document.activeElement;
			if (focusedElement !== this.buttonRef) {
				e.preventDefault();
				if (focusedElement === this.newProjectRef) {
					this.handleCreateProject();
				} else {
					focusedElement.click();
				}
			}
		}
	}

	focusNextInList() {
		const focusedElement = document.activeElement;
		if (focusedElement === this.buttonRef) {
			this.newTaskRef.focus();
			return;
		}
		const availableRefs = this.getAvailableRefs();
		for (var i = 0; i < availableRefs.length; i++) {
			const ref = availableRefs[i];
			if (ref === focusedElement) {
				if (i + 1 === availableRefs.length) {
					availableRefs[0].focus();
				} else {
					availableRefs[i + 1].focus();
				}
				return;
			}
		}
	}

	focusPreviousInList() {
		const focusedElement = document.activeElement;
		const availableRefs = this.getAvailableRefs();
		for (var i = 0; i < availableRefs.length; i++) {
			const ref = availableRefs[i];
			if (ref === focusedElement) {
				if (i === 0) {
					availableRefs[availableRefs.length - 1].focus();
				} else {
					availableRefs[i - 1].focus();
				}
				return;
			}
		}
	}

	getAvailableRefs() {
		const availableRefs = [this.newTaskRef];
		if (this.newProjectRef !== undefined) availableRefs.push(this.newProjectRef);
		if (this.newProjectGroupRef !== undefined) availableRefs.push(this.newProjectGroupRef);
		if (this.newTeamMemberRef !== undefined) availableRefs.push(this.newTeamMemberRef);
		if (this.newClientRef !== undefined) availableRefs.push(this.newClientRef);
		if (this.newInsightRef !== undefined) availableRefs.push(this.newInsightRef);
		if (this.newExpenseItemRef !== undefined) availableRefs.push(this.newExpenseItemRef);
		return availableRefs;
	}

	render() {
		const {formatMessage} = this.props.intl;

		const noFinance = !Util.hasFinance(this.props.viewer.company.modules);
		
		return (
			<div className="create-new-wrapper">
				<button
					id="create-new-btn"
					className={'create-new' + (this.state.expanded ? ' expanded' : '')}
					aria-haspopup="menu"
					aria-expanded={this.state.expanded}
					onMouseDown={this.toggleDropdown.bind(this)}
					onBlur={this.handleBlur.bind(this)}
					onKeyDown={this.handleKeyPress.bind(this)}
					ref={button => (this.buttonRef = button)}
					data-cy="page-header-create-new-btn"
				>
					<div className={'create-new-btn-text'}>{formatMessage({id: 'common.new'}).toUpperCase()}</div>
				</button>
				<ul className={'create-new-dropdown' + (this.state.expanded ? ' expanded' : '')} aria-hidden={!this.state.expanded} aria-labelledby="create-new-btn" role="menu">
					<li
						className="create-new-option task"
						role="menuitem"
						tabIndex="-1"
						onClick={this.handleCreateTask.bind(this)}
						onKeyDown={this.handleKeyPress.bind(this)}
						onBlur={this.handleBlur.bind(this)}
						ref={li => (this.newTaskRef = li)}
						data-cy="page-header-create-new-task"
					>
						<TaskIcon />
						<HeaderWrapper>
							<FormattedMessage id="common.task" />
						</HeaderWrapper>
					</li>
					{hasPermission(PERMISSION_TYPE.PROJECTS_CREATE) ? (
						<li
							className={'create-new-option project'}
							role="menuitem"
							tabIndex="-1"
							onClick={this.handleCreateProject.bind(this)}
							onKeyDown={this.handleKeyPress.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							ref={li => (this.newProjectRef = li)}
							data-cy="page-header-create-new-project"
						>
							<ProjectIcon />
							<HeaderWrapper>
								<FormattedMessage id="header.project" />
							</HeaderWrapper>
						</li>
					) : null}
					{hasPermission(PERMISSION_TYPE.PROJECTS_CREATE) ? (
						<li
							className="create-new-option project-group"
							role="menuitem"
							tabIndex="-1"
							onClick={this.handleCreateProjectGroup.bind(this)}
							onKeyDown={this.handleKeyPress.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							ref={li => (this.newProjectGroupRef = li)}
							data-cy="page-header-create-new-project-group"
						>
							<ConnectedProjectIcon />
							<HeaderWrapper>
								<FormattedMessage id="header.project_group" />
							</HeaderWrapper>
						</li>
					) : null}
					{isClientUser() || hasFeatureFlag("no_time_reg") ? null : (
						<li
							className="create-new-option time-entry"
							role="menuitem"
							tabIndex="-1"
							onClick={this.handleCreateTimeEntry.bind(this)}
							onKeyDown={this.handleKeyPress.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							ref={li => (this.newTimeEntryRef = li)}
							data-cy="page-header-create-new-time-entry"
						>
							<TimeEntryIcon />
							<HeaderWrapper>
								<FormattedMessage id="common.time_entry" />
							</HeaderWrapper>
						</li>
					)}
					{hasPermission(PERMISSION_TYPE.PERSON_CREATE) ? (
						<li
							className="create-new-option person"
							role="menuitem"
							tabIndex="-1"
							onClick={this.handleCreateTeamMember.bind(this)}
							onKeyDown={this.handleKeyPress.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							ref={li => (this.newTeamMemberRef = li)}
							data-cy="page-header-create-new-team-member"
						>
							<TeamMemberIcon />
							<HeaderWrapper>
								<FormattedMessage id="common.team_member" />
							</HeaderWrapper>
						</li>
					) : null}
					{hasPermission(PERMISSION_TYPE.CLIENT_CREATE) ? (
						<li
							className="create-new-option client"
							role="menuitem"
							tabIndex="-1"
							onClick={this.handleCreateClient.bind(this)}
							onKeyDown={this.handleKeyPress.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							ref={li => (this.newClientRef = li)}
							data-cy="page-header-create-new-client"
						>
							<ClientIcon />
							<HeaderWrapper>
								<FormattedMessage id="header.client" />
							</HeaderWrapper>
						</li>
					) : null}
					{hasPermission(PERMISSION_TYPE.INSIGHTS_CREATE) ? (
						<li
							className="create-new-option insight"
							role="menuitem"
							tabIndex="-1"
							onClick={this.handleCreateInsight.bind(this)}
							onKeyDown={this.handleKeyPress.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							ref={li => (this.newInsightRef = li)}
							data-cy="page-header-create-new-report"
						>
							<ReportIcon />
							<HeaderWrapper>
								<FormattedMessage id="header.new_report" />
							</HeaderWrapper>
						</li>
					) : null}
					{!isClientUser() ? (
						<li
							className={'create-new-option' + (noFinance ? ' disabled' : '')}
							role="menuitem"
							tabIndex="-1"
							onClick={noFinance ? () => null : this.handleCreateExpenseItem.bind(this)}
							onKeyDown={this.handleKeyPress.bind(this)}
							onBlur={this.handleBlur.bind(this)}
							ref={li => (this.newExpenseItemRef = li)}
							data-cy="page-header-create-new-expense-item"
							title={noFinance ? formatMessage({id: 'common.requires_financial_module'}) : null}
						>
							{noFinance ? <FinancialLockIcon /> : <ExpenseIcon />}
							<HeaderWrapper>
								<FormattedMessage id="header.expense-item" />
							</HeaderWrapper>
						</li>
					) : null}
				</ul>
			</div>
		);
	}
}

CreateNewMenu.propTypes = {
	viewer: PropTypes.object.isRequired,
	showTaskModal: PropTypes.func.isRequired,
};

export const HeaderWrapper = Styled.div`
	flex: auto;
	padding-left: 10px;
`;

export default injectIntl(withRouter(CreateNewMenu));
